import { Button } from '@material-ui/core'
import { ThemeProvider, createTheme } from '@material-ui/core/styles'
import { iframeResizer } from 'iframe-resizer'
import { SnackbarProvider, withSnackbar } from 'notistack'
import React from 'react'
import ReactDOM from 'react-dom'

const CompanionAPI = {}
export default CompanionAPI

class _Companion extends React.Component {
    iframeRef = React.createRef()
    attributes = JSON.parse(JSON.stringify(document.currentScript.dataset))

    componentDidMount() {
        window.addEventListener('message', this.handlePostMessage)

        iframeResizer({ checkOrigin: false }, this.iframeRef.current)

        // expose a navigate method for external scripts to use
        CompanionAPI.navigate = (path) => {
            this.messagePortal({ navigate: path })
        }

        console.log('Wylie Companion Ready')
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handlePostMessage)
    }

    showMessage = (msg, options) => {
        this.props.enqueueSnackbar(msg, {
            autoHideDuration: 3000,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
            // eslint-disable-next-line react/display-name
            action: options?.persist ? (key) => <Button onClick={() => { this.props.closeSnackbar(key) }}>Dismiss</Button> : undefined,
            ...options,
        })
    }

    showError = (err, options) => {
        this.showMessage(err.message || err, {
            variant: 'error',
            persist: true,
            style: { whiteSpace: 'pre-line' },
            // eslint-disable-next-line react/display-name
            action: (key) => <Button onClick={() => { this.props.closeSnackbar(key) }}>Dismiss</Button>,
            ...options,
        })
    }

    messagePortal = (msg) => {
        this.iframeRef.current?.contentWindow.postMessage({
            wylieScript: 'companion',
            attributes: this.attributes,
            ...JSON.parse(JSON.stringify(msg)),
        }, '*')
    }

    handlePostMessage = async (event) => {
        const { source, data } = event

        if (data?.wylieScript != 'portal') {
            return // not from our script
        }

        if (data.ping) {
            // tell the portal that we're here
            this.messagePortal({ pong: true })
        }

        if (data.redirect) {
            // tag the current url to allow redirecting back if needed
            const url = new URL(data.redirect)
            url.searchParams.append('origin', window.location.href)

            // go without adding to history
            window.location.replace(url)
        }

        if (data.showMessage) {
            this.showMessage(data.showMessage.msg, data.showMessage.options)
        }

        if (data.showError) {
            this.showError(data.showError.err, data.showError.options)
        }

        if (data.navigateAway) {
            window.location.href = data.navigateAway
        }

        if (data.notifyEvent) {
            if (data.notifyEvent == 'pageChange') {
                this.iframeRef.current?.scrollIntoView({ behavior: 'instant' })
            }
        }
    }

    render() {
        return <iframe
            ref={this.iframeRef}
            id="wylie-iframe"
            src={this.attributes.iframeUrl}
            style={{ width: '1px', minWidth: '100%'}}
            frameBorder="0"
        ></iframe>
    }
}

const Companion = withSnackbar(_Companion)

const root = document.createElement('div')
root.setAttribute('id', 'wylie-companion')

const defaultTheme = createTheme({
    palette: {
        type: 'light',
    },
})

ReactDOM.render(
    <ThemeProvider theme={defaultTheme}>
        <SnackbarProvider>
            <Companion />
        </SnackbarProvider>
    </ThemeProvider>,
    document.currentScript.parentNode.appendChild(root)
)
